import React from 'react';
import { Business, BUSINESSES } from '../data';
import { Reveal } from './Reveal';
function BusinessCard({
  business
}: {
  business: Business;
}) {
  const isComingSoon = business.status === 'coming-soon';
  const suitabilityLabel = isComingSoon ? 'Kommer erbjuda' : 'Perfekt för';
  return <article className={`overflow-hidden rounded-sm border ${isComingSoon ? 'border-terrakotta/35 bg-sand' : 'border-brun/10 bg-beige'}`} data-id="element-11" data-mp="p9we0hli2l01">
      <div className="relative overflow-hidden" data-id="element-12" data-mp="1ld2zub2fu49">
        <img src={business.cover} alt={business.place ? `${business.name} i ${business.place}` : business.name} className={`h-72 w-full object-cover transition-transform duration-[1200ms] hover:scale-105 md:h-96 ${isComingSoon ? 'saturate-[0.75]' : ''}`} data-id="element-13" data-mp="3tow7046awjoq" />
        <div className={`absolute inset-0 bg-gradient-to-t ${isComingSoon ? 'from-skog/80 via-skog/15' : 'from-brun/55 to-transparent'}`} data-id="element-14" data-mp="3ezghssmf4mb5" />
        {isComingSoon && <div className="absolute right-5 top-5 rounded-full bg-smorgul px-4 py-2 text-[10px] font-medium uppercase tracking-wide2 text-brun md:right-7 md:top-7" data-id="element-15" data-mp="39ykf2idsz67b">
            Kommer snart
          </div>}
        <div className="absolute bottom-0 left-0 p-7 md:p-9" data-id="element-16" data-mp="207bmpuxkzre4">
          {business.place && <p className="text-[11px] uppercase tracking-wide2 text-warm/70" data-id="element-17" data-mp="252qxuf47f96u">{business.place}</p>}
          <h3 className="mt-1 font-display text-3xl font-light text-warm md:text-4xl" data-id="element-18" data-mp="1cbpee1tharhi">
            {business.name}
          </h3>
        </div>
      </div>

      <div className="p-7 md:p-9" data-id="element-19" data-mp="1hblli9xh2z1a">
        <p className="text-[11px] uppercase leading-relaxed tracking-wide2 text-terrakotta" data-id="element-20" data-mp="1hcn5j3wguvv5">
          {business.services}
        </p>
        <div className="mt-6 max-w-2xl space-y-4 text-base leading-relaxed text-brun-soft" data-id="element-21" data-mp="1qbqqyej3vnct">
          {business.description.map(paragraph => <p key={paragraph} data-id="element-22" data-mp="2xr4wmx34a9jg">{paragraph}</p>)}
        </div>

        <div className="mt-9 border-t border-brun/10 pt-7" data-id="element-23" data-mp="31pcddrxkzaun">
          <p className="text-[11px] uppercase tracking-wide2 text-skog" data-id="element-24" data-mp="12lngluoqg8hh">{suitabilityLabel}</p>
          <ul className="mt-4 flex flex-wrap gap-2" aria-label={suitabilityLabel} data-id="element-25" data-mp="xn2pqlvdf15p">
            {business.perfectFor.map(occasion => <li key={occasion} className="rounded-full border border-brun/15 px-3 py-1.5 text-xs text-brun-soft" data-id="element-26" data-mp="1blahmfdjvca0">
                {occasion}
              </li>)}
          </ul>
        </div>

        <div className="mt-9 grid grid-cols-2 gap-3 sm:grid-cols-3" data-id="element-27" data-mp="iypszmoglea5">
          {business.gallery.map(item => <figure key={item.category} className="group" data-id="element-28" data-mp="ey5vghzz48nh">
              <div className="overflow-hidden rounded-sm" data-id="element-29" data-mp="snziqvvtykv3">
                <img src={item.image} alt={item.category} className="aspect-square w-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-30" data-mp="spkfms5mafw4" />
              </div>
              <figcaption className="mt-2 text-[11px] uppercase tracking-wide2 text-brun-soft" data-id="element-31" data-mp="3rconskzp2tm2">
                {item.category}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </article>;
}
export function Businesses() {
  return <section id="verksamheter" className="w-full bg-warm py-28 md:py-40" data-id="element-32" data-mp="1xvix9czf5nfh">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-33" data-mp="1xt65k83uzyp8">
        <Reveal className="max-w-3xl" data-id="element-34" data-mp="22uvkhyu7cwil">
          <p className="mb-6 text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-35" data-mp="22rpqc56pv4g0">Våra verksamheter</p>
          <h2 className="font-display text-4xl font-light leading-tight text-brun md:text-5xl" data-id="element-36" data-mp="2ul9q77s2b2j6">
            Vi väljer inte ut flest – vi väljer ut bäst.
          </h2>
          <p className="mt-7 max-w-2xl text-lg leading-relaxed text-brun-soft" data-id="element-37" data-mp="2gl8q3ujmfz4r">
            Smaken som Baken samlar verksamheter som vi själva tror på. Gemensamt för dem alla är ett kompromisslöst fokus på smak, kvalitet och hantverk.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-10 md:mt-20 lg:grid-cols-2" data-id="element-38" data-mp="1a5oj8s3d5stn">
          {BUSINESSES.map((business, index) => <Reveal key={business.name} delay={index * 0.08} className={index === 0 ? 'lg:col-span-2' : ''} data-id="element-39" data-mp="1pfuxfvj1kzto" data-mpi={index}>
              <BusinessCard business={business} data-id="element-40" data-mp="1kms1jgqsleab" />
            </Reveal>)}
        </div>

        <Reveal className="mx-auto mt-24 max-w-3xl text-center md:mt-32" data-id="element-41" data-mp="1gn9hen6sp78j">
          <p className="text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-42" data-mp="1bopx0r7uo3ia">Fler smaker väntar</p>
          <h3 className="mt-6 font-display text-3xl font-light leading-tight text-brun md:text-4xl" data-id="element-43" data-mp="28cw6brfpvk2w">
            Smaken som Baken börjar med fyra verksamheter som vi känner utan och innan.
          </h3>
          <p className="mt-7 text-lg leading-relaxed text-brun-soft" data-id="element-44" data-mp="1zc6bor26zzqr">
            De delar samma filosofi, samma kvalitetskrav och samma passion för riktigt bra mat. I takt med att plattformen växer kommer vi att välkomna fler handplockade producenter, bagerier, restauranger, caféer, kockar och dryckesaktörer från hela Småland.
          </p>
          <p className="mt-8 font-display text-xl italic leading-relaxed text-bourgogne md:text-2xl" data-id="element-45" data-mp="j1c7vfae8c8q">
            Inte för att bli störst. Utan för att fortsätta vara den plats där du alltid hittar det vi själva hade valt att servera våra egna gäster.
          </p>
        </Reveal>
      </div>
    </section>;
}